import { configure } from "mobx";

configure({ useProxies: "never" });

console.log('mobx configure run...');